export const createTaxonomyCountRefreshScheduler = ({
    getIds,
    request,
    applyCounts,
    onError,
    delay = 1000,
}) => {
    let timeoutId;
    let inFlight = false;
    let trailingRefresh = false;
    let disposed = false;
    let callbacks = [];

    const finishCallbacks = () => {
        const pendingCallbacks = callbacks;
        callbacks = [];
        pendingCallbacks.forEach(callback => callback());
    };

    const scheduleRequest = () => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(run, delay);
    };

    const run = async () => {
        timeoutId = undefined;
        inFlight = true;

        try {
            const ids = getIds();
            const counts = ids.length ? await request(ids) : [];
            if (!disposed) applyCounts(counts);
        } catch (error) {
            if (!disposed) onError?.(error);
        } finally {
            inFlight = false;
            if (disposed) return;

            if (trailingRefresh) {
                trailingRefresh = false;
                scheduleRequest();
            } else {
                finishCallbacks();
            }
        }
    };

    return {
        schedule(callback) {
            if (disposed) return;
            if (callback) callbacks.push(callback);

            if (inFlight) {
                trailingRefresh = true;
            } else {
                scheduleRequest();
            }
        },

        dispose() {
            disposed = true;
            clearTimeout(timeoutId);
            callbacks = [];
        },
    };
};
